import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';
import { registerServiceWorker, setupInstallPrompt } from './lib/utils/pwa';

// Register Service Worker for PWA
registerServiceWorker();
setupInstallPrompt();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
